import { LandingNavbar } from './LandingNavbar';
import { HeroSection } from './HeroSection';
import { OffersSection } from './OffersSection';
import { TrustBar } from './TrustBar';
import { HowItWorks } from './HowItWorks';
import { FeatureSection } from './FeatureSection';
import { AppPromoBanner } from './AppPromoBanner';
import { LandingFooter } from './LandingFooter';
import { BottomNavigation } from './BottomNavigation';
import { AppHeader } from './AppHeader';
import { useAuth } from '../hooks/useAuth';
import { useBooking } from '../hooks/useBooking';
import { useNavigation } from '../hooks/useNavigation';

/**
 * Landing Page - Página principal
 * 
 * REFACTORIZADO:
 * - Ya no recibe props (antes recibía 10+ callbacks)
 * - Usa hooks para acceder a estado y acciones
 * - Mucho más limpio y mantenible
 */
export const LandingPage = () => {
  // Hooks para acceder a servicios (como inyectar Services en Angular)
  const { isLoggedIn, user, logout } = useAuth();
  const { startSearch } = useBooking();
  const { goToProfile, goToMyTickets, goToSettings, goToLogin } = useNavigation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Mobile Header */}
      <AppHeader 
        className="lg:hidden"
        userName={user?.name || 'Usuario'}
        onProfileClick={goToProfile}
        onMyTicketsClick={() => goToMyTickets('active')}
        onSettingsClick={goToSettings}
        onLogoutClick={logout}
        isLoggedIn={isLoggedIn}
        onLoginClick={goToLogin}
        onLogoClick={scrollToTop}
      />
      
      {/* Desktop Header */}
      <LandingNavbar 
        className="hidden lg:block"
        onLogoClick={scrollToTop}
        isLoggedIn={isLoggedIn}
        userName={user?.name || 'Usuario'}
        onProfileClick={goToProfile}
        onMyTicketsClick={() => goToMyTickets('active')}
        onSettingsClick={goToSettings}
        onLogoutClick={logout}
        onLoginClick={goToLogin}
      />
      
      <HeroSection onSearch={startSearch} />
      <OffersSection />
      <TrustBar />
      <HowItWorks />
      <FeatureSection />
      <AppPromoBanner />
      <LandingFooter />
      <BottomNavigation 
        activePage="home" 
        onAccountClick={goToProfile} 
        onMyTripsClick={() => goToMyTickets('active')}
        onHomeClick={scrollToTop}
      />
    </div>
  );
};

export default LandingPage;